var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }